module.exports = __webpack_public_path__ + "static/media/sikar-cs.8e0cb4e4.png";